<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_681)">
    <path
      d="M10.7763 7.68424C11.5446 6.37418 11.9288 5.71915 12.5016 5.71917C13.0745 5.7192 13.4586 6.37426 14.2268 7.68439L18.1529 14.3801C19.344 16.4116 19.9396 17.4273 19.4841 17.9678C19.0285 18.5083 17.9266 18.0933 15.7228 17.2635L13.2036 16.3148C12.8548 16.1835 12.6805 16.1179 12.4983 16.1179C12.3162 16.1179 12.1419 16.1837 11.7932 16.3151L9.28062 17.2625C7.07561 18.0938 5.9731 18.5095 5.51736 17.9689C5.06161 17.4284 5.65769 16.412 6.84984 14.3793L10.7763 7.68424Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_681">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
